// This is the generic Thank You Page for Single Courses EXCEPT CWD!
import React, { useEffect } from "react"
import get from "lodash/get"
import { graphql } from "gatsby"
import WhiteAcademyIcon from "../svg/ZTM-Logo-Academy-White.svg"

import {
  ThankYouPageContainer,
  ThankYouHeaderContainer,
  ThankYouTitle,
  SubTitle,
  VideoContainer,
  VideoInnerContainer,
  VideoWrapper,
  ThankYouLetterOuterGrid,
  ThankYouLetterGrid,
  ThankYouLetterContainer,
  ImgContainer,
  AndreiThankYouImage,
  SignatureThankYouContainer,
  ThankYouGridLowerContainer,
  ThankYouContactMessageContainer,
  Contact,
  ContactSupport,
  ThankYouMessage,
  ThankYouCardsGridContainer,
  ThankYouCardOuterContainer
} from "../page-styles/thank-you.styles"

import { Seo } from "../components/seo.jsx"
import ThankYouCard from "../components/thankyou-card/thankyou-card.component.jsx"
import TrackThankyouConversion from "../helpers/thankyouTracking.helper.jsx"

export const Head = ({ location, data }) => {
  return (
    <Seo
      metaData={data.allContentfulPageMeta.nodes[0]}
      uri={location.pathname}
    />
  )
}
const ThankYouIndex = (props) => {
  const thankYouData = get(props, "data.allContentfulThankYouPage.nodes")[0]

  // /* eslint-disable */
  // useEffect(() => {
  //   TrackThankyouConversion({
  //     props,
  //     plan: "Free Week Trial",
  //   })
  // }, [])
  // /* eslint-enable */

  const {
    title,
    subtitle,
    body,
    avatarImg,
    image2,
    image3,
    thankYouCards, // JSON object
    thankyouMessage,
    newThankYouVideo
  } = thankYouData


  const imageData = [image2, image3]

  return (
    <ThankYouPageContainer>
      <ThankYouHeaderContainer className="full-bleed">
        <WhiteAcademyIcon />
          <ThankYouTitle>{title}</ThankYouTitle>
          <SubTitle>{subtitle}</SubTitle>
      </ThankYouHeaderContainer>
      <VideoContainer>
        <VideoInnerContainer>
          <VideoWrapper>
            <iframe
              src={newThankYouVideo}
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
            />
          </VideoWrapper>
        </VideoInnerContainer>
      </VideoContainer>
      <ThankYouLetterOuterGrid>
        <ThankYouLetterGrid>
          <ThankYouLetterContainer
            dangerouslySetInnerHTML={{
              __html: body.childMarkdownRemark.html,
            }}
          />
          <ImgContainer>
            <AndreiThankYouImage
              src={`${avatarImg.file.url}?w=100&fm=webp`}
              alt="Andrei image"
              loading="lazy"
            />
            <SignatureThankYouContainer>
              <h6> Andrei Neagoie</h6>
              <span>Founder & Lead Instructor</span>
            </SignatureThankYouContainer>
          </ImgContainer>
        </ThankYouLetterGrid>
      </ThankYouLetterOuterGrid>
      <ThankYouGridLowerContainer>
        <ThankYouCardsGridContainer>
          <ThankYouCardOuterContainer>
          {thankYouCards.map((data, i) => (
            <ThankYouCard data={data} key={i} imageData={imageData[i]} id={i} />
          ))}
        </ThankYouCardOuterContainer>
        <ThankYouContactMessageContainer>
        <Contact />
        <div>
          <ContactSupport>CONTACT US</ContactSupport>
          <ThankYouMessage
          dangerouslySetInnerHTML={{
            __html: thankyouMessage.childMarkdownRemark.html,
          }}
          />
        </div>
      </ThankYouContactMessageContainer>
    </ThankYouCardsGridContainer>
    </ThankYouGridLowerContainer>
    </ThankYouPageContainer>    
  )
}

export default ThankYouIndex

export const thankYouQuery = graphql`
  query ThankYouIndexQuery {
    allContentfulPageMeta(
      filter: { contentful_id: { eq: "42bQNsnOjtqpLosOGUHxeQ" } }
    ) {
      nodes {
        pageTitle
        pageRobots
        footerCtaContent {
          childMarkdownRemark {
            html
          }
        }
        footerCtaButtonText
        footerCtaLink
      }
    }

    allContentfulThankYouPage(
      filter: { contentful_id: { eq: "1Ox5kW7Wu6DUf7jjzTR3ds" } }
    ) {
      nodes {
        body {
          childMarkdownRemark {
            html
          }
        }
        subtitle
        title
        avatarImg {
          file {
            url
          }
        }
        thankyouMessage {
          childMarkdownRemark {
            html
          }
        }
        newThankYouVideo
        image2 {
          gatsbyImageData(placeholder: BLURRED, width: 500)
        }
        image3 {
          gatsbyImageData(placeholder: BLURRED, width: 500)
        }
        thankYouCards {
          title
          desc
          buttonURL
          buttonText
        }
      }
    }
  }
`
